/**
 * Barrel for the /merchant Staff shared logic layer.
 *
 * Screen-agents import from `@/merchant-app/lib`:
 *   - formatters as named fns (`cpf`, `phone`, …) or the `fmt` namespace
 *     (`fmt.cpf(...)`, matching the spec's `fmt.cpf` wording);
 *   - status types + mappers (`userStatusPill`, `STATUS_TABS`, …).
 */
import * as format from './format';

export * from './format';
export * from './status';

/** Namespaced formatters: `fmt.cpf(v)`, `fmt.brl(v)`, `fmt.initials(name)`, … */
export const fmt = format;
